import { Theme } from './symbols';

export const royalTheme: Theme = {
  name: 'royal',
  properties: {
    '--primary-color': 'rgba(151,37,148,1)',
    '--primary-light': 'rgba(151,37,148,0.1)',
    '--secondary-color': 'rgba(136, 136, 136, 1)',
    '--complementary-color': 'rgba(39,54,85,1)',
  }
};